import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import DiscussionPage from 'flarum/forum/components/DiscussionPage';
import DiscussionControls from 'flarum/forum/utils/DiscussionControls';
import LinkButton from 'flarum/common/components/LinkButton';
import Button from 'flarum/common/components/Button';
const isPhone = () => window.matchMedia('(max-width: 767px)').matches;
const getPrivateComposing = () => {
  try {
    const PrivateComposing = flarum.reg.get('fof-byobu', 'forum/pages/PrivateComposing');
    return PrivateComposing ? new PrivateComposing() : null;
  } catch (_) {
    return null;
  }
};
app.initializers.add('val-ui-private-discussion-sidebar', () => {
  /*
   * DESKTOP
   *
   * Deux vrais boutons dans la colonne de droite,
   * juste avant les contrôles de la discussion.
   */
  extend(DiscussionPage.prototype, 'sidebarItems', function (items) {
    const discussion = this.discussion;
    if (!discussion?.isPrivateDiscussion?.() || isPhone()) {
      return;
    }
    items.add('valPrivateList', LinkButton.component({
      href: app.route('byobuPrivate'),
      icon: app.forum.data.attributes['byobu.icon-badge'] || 'far fa-envelope',
      className: 'Button Button--block ValPrivateSidebarButton ValPrivateSidebarButton--list'
    }, app.translator.trans('fof-byobu.forum.nav.nav_item')), 120);
    if (app.session.user && app.forum.attribute('canStartPrivateDiscussion')) {
      const composing = getPrivateComposing();
      if (composing) {
        items.add('valPrivateCompose', Button.component({
          icon: 'fas fa-pen',
          className: 'Button Button--block Button--primary ValPrivateSidebarButton ValPrivateSidebarButton--compose',
          onclick: composing.action.bind(composing)
        }, app.translator.trans('fof-byobu.forum.nav.start_button')), 110);
      }
    }
  });

  /*
   * MOBILE
   *
   * Les deux commandes entrent dans le menu ⋮ natif
   * de la discussion. Aucun bouton supplémentaire
   * n'est affiché sous le Hero.
   */
  extend(DiscussionControls, 'controls', function (items, discussion) {
    if (!isPhone() || !discussion?.isPrivateDiscussion?.()) {
      return;
    }
    items.add('valPrivateList', Button.component({
      icon: app.forum.data.attributes['byobu.icon-badge'] || 'far fa-envelope',
      onclick: () => {
        m.route.set(app.route('byobuPrivate'));
      }
    }, app.translator.trans('fof-byobu.forum.nav.nav_item')), 1000);
    if (app.session.user && app.forum.attribute('canStartPrivateDiscussion')) {
      const composing = getPrivateComposing();
      if (composing) {
        items.add('valPrivateCompose', Button.component({
          icon: 'fas fa-pen',
          onclick: composing.action.bind(composing)
        }, app.translator.trans('fof-byobu.forum.nav.start_button')), 990);
      }
    }
  });
}, -100);